import { createStore } from '../genericStore'
import { marker } from './marker'

export const markerStore = createStore(marker);